/**
 * Custom Design Showcase — multi-row slider
 * The section now renders FOUR independent sliders (Styles, Fabrics,
 * Designs, Colors), each its own [data-cds-slider] scope. This inits
 * every one of them independently within the section, rather than
 * assuming a single slider per section. Each row is a plain horizontally
 * scrolling, scroll-snap track — no item-count assumptions, since the
 * number of PNGs per category varies page to page. Prev/next buttons
 * step by one card width (measured live), and a thin progress bar
 * tracks scroll position instead of one-dot-per-item. Native touch
 * scroll/swipe works automatically because each track is a real scroll
 * container — no custom gesture handling needed.
 */
(function () {
  'use strict';

  function initSlider(root) {
    var track = root.querySelector('[data-cds-track]');
    var prevBtn = root.querySelector('[data-cds-prev]');
    var nextBtn = root.querySelector('[data-cds-next]');
    var progressBar = root.querySelector('[data-cds-progress]');

    if (!track || track.dataset.cdsInit) return;
    track.dataset.cdsInit = 'true';

    function cardStep() {
      var card = track.querySelector('.cds-card');
      if (!card) return track.clientWidth;
      var trackStyle = window.getComputedStyle(track);
      var gap = parseFloat(trackStyle.columnGap || trackStyle.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateState() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var pct = maxScroll > 0 ? (track.scrollLeft / maxScroll) * 100 : 0;

      if (progressBar) {
        progressBar.style.width = pct + '%';
      }
      if (prevBtn) {
        prevBtn.disabled = track.scrollLeft <= 2;
      }
      if (nextBtn) {
        nextBtn.disabled = maxScroll <= 2 || track.scrollLeft >= maxScroll - 2;
      }
    }

    function step(direction) {
      track.scrollBy({ left: direction * cardStep(), behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        step(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        step(1);
      });
    }

    track.addEventListener('scroll', updateState, { passive: true });
    window.addEventListener('resize', updateState);

    updateState();
  }

  function initAllWithin(scope) {
    var roots = scope.querySelectorAll('[data-cds-slider]');
    roots.forEach(initSlider);
  }

  function initAll() {
    initAllWithin(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    initAllWithin(evt.target);
  });
})();